import React from 'react';
import Img from 'gatsby-image';
import Link from 'gatsby-link';
import Scroll from '../components/Scroll';
import Hero from '../components/Hero';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';
import SEO from '../components/SEO';

const SiteData = {
  title: 'Certyfikaty',
  slug: '/certyfikaty',
};

const certyficates = [
  {
    name: 'certyficateImg_01',
    title: 'Amortyzatory i sprzęgła',
  },
  {
    name: 'certyficateImg_02',
    title: 'Skrzynie biegów',
  },
  {
    name: 'certyficateImg_03',
    title: 'Układy wtryskowe',
  },
  {
    name: 'certyficateImg_04',
    title: 'Układ rozrządu',
  },
  {
    name: 'certyficateImg_05',
    title: 'Naprawy blacharsko-lakiernicze',
  },
  {
    name: 'certyficateImg_06',
    title: 'Części zamienne',
  },
  {
    name: 'certyficateImg_07',
    title: 'Części zamienne',
  },
  {
    name: 'certyficateImg_08',
    title: 'Naprawy blacharsko-lakiernicze',
  },
];

class Certificates extends React.Component {
  constructor() {
    super();
    this.state = { currentImage: 0 };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }
  openLightbox(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true,
    });
  }
  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }
  render() {
    const { data } = this.props;
    const photos = [
      { src: `${data.certyficateImg_01.resolutions.src}`, width: 1, height: 1.51 },
      { src: `${data.certyficateImg_02.resolutions.src}`, width: 1, height: 1.51 },
      { src: `${data.certyficateImg_03.resolutions.src}`, width: 1, height: 1.51 },
      { src: `${data.certyficateImg_04.resolutions.src}`, width: 1, height: 1.51 },
      { src: `${data.certyficateImg_05.resolutions.src}`, width: 1, height: 1.51 },
      { src: `${data.certyficateImg_06.resolutions.src}`, width: 1, height: 1.51 },
      { src: `${data.certyficateImg_07.resolutions.src}`, width: 1, height: 1 },
      { src: `${data.certyficateImg_08.resolutions.src}`, width: 1, height: 1 },
    ];

    return (
      <div>
        <SEO isSeo siteData={SiteData} type="Local Business" />
        <div className="theme-page padding-bottom-70">
          <Hero image={data.certyficateHero.sizes} heading="Poznaj nasze kompetencje">
            <div className=" margin-top-67 padding-bottom-20">
              <Scroll type="id" element="certyficates">
                <a className="more">
                  <span>zobacz certyfikaty</span>
                </a>
              </Scroll>
            </div>
          </Hero>
          <div id="certyficates" className="row gray full-width page-header vertical-align-table">
            <div className="row full-width padding-top-bottom-50 vertical-align-cell">
              <div className="row">
                <div className="page-header-left">
                  <h1>Certyfikaty które posiadamy</h1>
                </div>
                <div className="page-header-right">
                  <div className="bread-crumb-container">
                    <label>JESTEŚ TUTAJ:</label>
                    <ul className="bread-crumb">
                      <li>
                        <Link to="/">STRONA GŁÓWNA</Link>
                      </li>
                      <li className="separator">&#47;</li>
                      <li>CERTYFIKATY</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="clearfix">
            <div className="row gallery-cert">
              {/* <ul className="galleries-list isotope">
              {certyficates.map(item => (
                <li key={item.name} className="transmission">
                  <img src={data[item.name].resolutions.src} imgStyle={{ objectPosition: '0 0' }} />
                  <div className="view align-center">
                    <div className="vertical-align-table">
                      <div className="vertical-align-cell">
                        <p className="description">{item.title}</p>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul> */}
              <Gallery photos={photos} onClick={this.openLightbox} />
              <Lightbox
                images={photos}
                onClose={this.closeLightbox}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                currentImage={this.state.currentImage}
                isOpen={this.state.lightboxIsOpen}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const query = graphql`
  query CertyficatesPage {
    certyficateHero: imageSharp(id: { regex: "/certyficateHero/" }) {
      sizes(maxWidth: 1920, maxHeight: 900) {
        ...GatsbyImageSharpSizes
      }
    }
    certyficateImg_01: imageSharp(id: { regex: "/certyficate_01/" }) {
      resolutions(width: 2479, height: 3507) {
        ...GatsbyImageSharpResolutions
      }
    }
    certyficateImg_02: imageSharp(id: { regex: "/certyficate_02/" }) {
      resolutions(width: 2479, height: 3507) {
        ...GatsbyImageSharpResolutions
      }
    }
    certyficateImg_03: imageSharp(id: { regex: "/certyficate_03/" }) {
      resolutions(width: 2479, height: 3507) {
        ...GatsbyImageSharpResolutions
      }
    }
    certyficateImg_04: imageSharp(id: { regex: "/certyficate_04/" }) {
      resolutions(width: 2479, height: 3507) {
        ...GatsbyImageSharpResolutions
      }
    }
    certyficateImg_05: imageSharp(id: { regex: "/certyficate_05/" }) {
      resolutions(width: 2479, height: 3507) {
        ...GatsbyImageSharpResolutions
      }
    }
    certyficateImg_06: imageSharp(id: { regex: "/certyficate_06/" }) {
      resolutions(width: 2479, height: 3507) {
        ...GatsbyImageSharpResolutions
      }
    }
    certyficateImg_07: imageSharp(id: { regex: "/certyficate_07/" }) {
      resolutions(width: 2479, height: 3507) {
        ...GatsbyImageSharpResolutions
      }
    }
    certyficateImg_08: imageSharp(id: { regex: "/certyficate_08/" }) {
      resolutions(width: 2479, height: 3507) {
        ...GatsbyImageSharpResolutions
      }
    }
  }
`;

export default Certificates;



// WEBPACK FOOTER //
// ./src/pages/certyfikaty.js